import { Menu } from "@/components/Navigation/Buttons/HeaderButton/components/menu/menu";
import { Alerts } from "@/components/Navigation/Buttons/HeaderButton/components/trigger/components/alerts";
import { Chevron } from "@/components/Navigation/Buttons/HeaderButton/components/trigger/components/chevron";
import { Content } from "@/components/Navigation/Buttons/HeaderButton/components/trigger/components/content";
import { Icon } from "@/components/Navigation/Buttons/HeaderButton/components/trigger/components/icon";
import { Trigger } from "@/components/Navigation/Buttons/HeaderButton/components/trigger/trigger";
import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";
import { Base } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";

export const HeaderButton = Object.assign(Base, {
    useContext: useHeaderButtonContext,
    Trigger: Object.assign(Trigger, {
        Content: Content,
        Icon: Object.assign(Icon, {
            Alerts: Alerts
        }),
        Chevron: Chevron
    }),
    Menu: Menu
});
